export const coderRoleType = {
    A: "a",
    B: "b",
};

export const coderRoleLabel = {
    A: "Coder A",
    B: "Coder B",
};

export const attributeSource = {
    OCR: "Ocr",
    Human: "Human",
};

export const brandVerifiedAttributeClasses = {
    PENDING: "pending",
    ACCEPTED: "accepted",
    REJECTED: "rejected",
    AUTO_ACCEPTED: "auto_accepted",
};

export const brandVerifiedAttributeStatus = {
    Pending: 0,
    Accepted: 1,
    Rejected: 2,
    AutoAccepted: 3,
};

export const attributeGroupNames = {
    FQA_SIZE: "FqaSizeAttributes",
    FQA_IDENTIFYING: "FqaIdentifyingAttributes",
    CODING_SIZE: "IntakeCodingSizeAttributes",
    CODING_IDENTIFYING: "IntakeCodingIdentifyingAttributes",
    CODING_ADDITIONAL: "IntakeCodingAdditionalAttributes",
    MARKETING_ATTRIBUTES: "IntakeMarketingAttributes",
};
